import $ from "jquery";
$(document).ready(function(){
    $('.c-feature-carousel__slider').each(function(){
        let slickIndividual = $(this);
        slickIndividual.slick({
            nextArrow: slickIndividual.next().find('.next-arrow'),
            prevArrow: slickIndividual.next().find('.prev-arrow')
        });
    })
});